import modifiedGlobals from './modified-globals';

export default {
  modifiedGlobals,
};
